import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../assets/footer/footer_home_icon.svg';
import { ReactComponent as CycleIcon } from '../assets/footer/footer_cycle_icon.svg';
import { ReactComponent as MentalIcon } from '../assets/footer/footer_mental_icon.svg';
import { ReactComponent as SportIcon } from '../assets/footer/footer_sport_icon.svg';
import { ReactComponent as BlogIcon } from '../assets/footer/footer_blog_icon.svg';
import { ReactComponent as CalIcon } from '../assets/cycle/calendrier_icon.svg';
import './Footer.css';

const tabs = [
  { path: '/accueil',     label: 'Home',    Icon: HomeIcon },
  { path: '/cycle',       label: 'Cycle',   Icon: CycleIcon },
  { path: '/mental',      label: 'Mental',  Icon: MentalIcon },
  { path: '/sport',       label: 'Sport',   Icon: SportIcon },
  { path: '/blog',        label: 'Blog',    Icon: BlogIcon },
  { path: '/calendrier',  label: 'Calendrier', Icon: CalIcon },
];

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="footer">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;
        return (
          <button
            key={tab.path}
            className={`footer__tab${isActive ? ' footer__tab--active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <tab.Icon className="footer__icon" />
            <span className="footer__label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default Footer;
